import {state as lifecycle} from 'fragments/lifecycle';
import {emptyPagination} from 'constants/pagination';

export default {
	...lifecycle,
	buildingsQuery: {
		_page: 1,
		manufacturingYearEnd: null,
		areas: [],
		campaign: null,
		dismissPrompt: false,
		tagIds: '',
	},
	buildings: [],
	buildingsLoading: false,
	buildingsPagination: emptyPagination,
	processing: false,
	areasSelectorOpen: false,
	areasSelectorSearch: '',
	callCampaigns: [],
	callCampaignCreatorOpen: false,
	lastVisitedBuilding: null,
	lastVisitedBuildingLoading: false,
	availableTags: [],
};
